module.exports = __webpack_public_path__ + "7bf95324a44dce7c2ef3242eed0ff992.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/youth-trio.png
// module id = 481
// module chunks = 0